import { Location } from '@angular/common';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ApiService } from 'src/app/services/api.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import endpoints from 'src/app/helpers/endpoints';

@Component({
  selector: 'fury-add-block-phone-number',
  templateUrl: './add-block-phone-number.component.html',
  styleUrls: ['./add-block-phone-number.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class AddBlockPhoneNumberComponent implements OnInit, OnDestroy {
  blockContactForm!: FormGroup;
  ngUnsubscribe = new Subject<void>();

  constructor(
    private apiService: ApiService,
    public location: Location,
    ) { }

  ngOnInit(): void {
    this.formInit();
  }

  formInit(){
    this.blockContactForm = new FormGroup({
      phoneNumbers: new FormArray([new FormControl('', [Validators.required, Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/)])],),
    })
  }

  get blockContact() {
    return this.blockContactForm.get('phoneNumbers') as FormArray;
  }


  addField() {
    const newField = new FormControl('', [Validators.required, Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/)]);
    this.blockContact.push(newField);
  }

  removeField(index: number) {
    this.blockContact.removeAt(index);
  }

  add(){
    if(this.blockContactForm.valid){
      this.apiService.patch(endpoints.blockContacts.blockNumbers.addBlockPhoneNumbers, this.blockContactForm.value).pipe(takeUntil(this.ngUnsubscribe)).subscribe(({
        next: (res: HttpResponse<any>)=>{
          if(res.body){
            this.apiService.alert(res.body.message, ErrorType.Success);
            this.location.back();
          }
        }, 
        error: (err: HttpErrorResponse)=>{
          this.apiService.alert(err.message, ErrorType.Error);
        }
      }))
    } else {
      this.blockContactForm.markAllAsTouched();
    }
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
